<template>
  <div class="view-panel">
    <div class="view-wrapper">
      <div class="view-title-bar">
        <span class="view-title">{{ title }}</span>
        <slot name="title"></slot>
      </div>
      <div class="view-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'realtimeOverviewPanel',
  props: {
    title: {
      type: String
    }
  }
}
</script>
<style lang="sass">
@import './styles/panel'
</style>
